import React from 'react';

const BtnDelete = (props) => {
  return (
      <button className="btn-delete" onClick={()=>props.handleDelete(props.bot)}>Delete</button>
  );
}

export default BtnDelete;
